"use strict";

var _productParsers;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Product = require('../../interfaces/Product');

var CONSTANTS = require('../../constants');

var parseDesignName = require('../parseDesignName'); // const parseTransaction = require('./parseTransaction');


var parseVellumJacketsPackage = require('./parseVellumJacketsPackage');

var parseWaxSealsPackage = require('./parseWaxSealsPackage');

var parseTableNumbers = require('./parseTableNumbers');

var parseSilkRibbonSpools = require('./parseSilkRibbonSpools');

var parseSilkRibbonSamples = require('./parseSilkRibbonSamples');

var parseClassicInvitationSamples = require('./parseClassicInvitationSamples');

var parseLetterpressInvitationSamples = require('./parseLetterpressInvitationSamples');

var productParsers = (_productParsers = {}, _defineProperty(_productParsers, CONSTANTS.VELLUM_JACKETS, parseVellumJacketsPackage), _defineProperty(_productParsers, CONSTANTS.WAX_SEALS, parseWaxSealsPackage), _defineProperty(_productParsers, CONSTANTS.TABLE_NUMBERS, parseTableNumbers), _defineProperty(_productParsers, CONSTANTS.SILK_RIBBON, parseSilkRibbonSpools), _defineProperty(_productParsers, CONSTANTS.SILK_RIBBON_SAMPLES, parseSilkRibbonSamples), _defineProperty(_productParsers, CONSTANTS.LETTERPRESS_WEDDING_INVITATION_SAMPLES, parseLetterpressInvitationSamples), _defineProperty(_productParsers, CONSTANTS.CLASSIC_WEDDING_INVITATION_SAMPLES, parseClassicInvitationSamples), _productParsers);

function createShineProductFromEtsyTransaction(transaction, receipt, options) {
  if (!Object.prototype.isPrototypeOf.call(Product.prototype, this)) {
    throw new Error('createShineProductFromEtsyTransaction must be called with a product as "this"');
  }

  var parserFn = productParsers[this.product_type];

  if (!parserFn) {
    console.warn("No parser function found for ".concat(this.product_type, ". If this is expected, you can disregard this message."));
    this.defaults();
  }

  this.design_name = parseDesignName(transaction.title, options);
  this.customer_notes = receipt.message_from_buyer || '';

  if (parserFn) {
    parserFn.call(this, transaction, receipt, options);
  }

  return true;
}

module.exports = createShineProductFromEtsyTransaction;